import Button from '../core/Button';
import { cn } from '@/helpers/classnames';
import { ViewConfig } from '@/types/views';
import { checkUserPermissions } from '../Auth/checkUserPermissions';
import { NotificationDot } from '@/components/NotificationDot';
import { FormattedMessage, useIntl } from 'react-intl';

interface HeaderMenuProps {
  options: ViewConfig[];
  selected?: string;
  className?: string;
  onViewChange: (view: string) => void;
  notificationViews?: string[];
  notificationLabels?: Record<string, string>;
  ariaLabel?: string;
}

export const HeaderMenu = ({
  options,
  className,
  selected,
  onViewChange,
  notificationViews,
  notificationLabels,
  ariaLabel,
}: HeaderMenuProps) => {
  const { formatMessage } = useIntl();

  return (
    <nav
      className={cn('my-3 flex gap-1', className)}
      aria-label={ariaLabel ?? formatMessage({ defaultMessage: 'Undermeny' })}
    >
      {options
        .filter(
          (option) =>
            !option.permission ||
            checkUserPermissions({ permission: option.permission }),
        )
        .map((option) => (
          <Button
            key={option.path}
            variant={selected === option.path ? 'filled' : 'ghost'}
            onClick={() => onViewChange(option.path)}
            className="relative flex"
            aria-current={selected === option.path ? 'page' : undefined}
          >
            {notificationViews && notificationViews.includes(option.path) && (
              <NotificationDot label={notificationLabels?.[option.path]} />
            )}
            {option.defaultMessage ?? <FormattedMessage id={option.label} />}
          </Button>
        ))}
    </nav>
  );
};
